var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-link-message",class:_vm.bgClass},[_c('span',[_vm._v(_vm._s(_vm.data.filename))]),_c('a',{attrs:{"href":_vm.data.url,"target":"_blank"}},[_vm._v("查看详情")])])}
var staticRenderFns = []

export { render, staticRenderFns }